import { Line, LineChart, ResponsiveContainer } from "recharts";
import { useTheme } from "@/components/theme-provider";

export function VroomSparkline({
  data,
  height = 24,
}: {
  data: { value: number }[];
  height?: number;
}) {
  const { resolvedTheme } = useTheme();
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} key={resolvedTheme} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
        <Line
          dataKey="value"
          stroke="var(--p-500)"
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
